// extracted by css-extract-rspack-plugin
export default {"cls1":"PremiumBadge-cls1_s3F","cls2":"PremiumBadge-cls2_rgf PremiumBadge-cls1_s3F"};